import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const klaviyo = defineConnector({
  identifier: "klaviyo",
  name: "Klaviyo",
  tagLine: "Email and SMS marketing",
  keywords:
    "marketing automation profiles lists segments flows campaigns ecommerce",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://a\\.klaviyo\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Klaviyo-API-Key",
      },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Klaviyo](https://www.klaviyo.com/) and navigate to Settings > Account > API Keys to create a private API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Klaviyo API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://a.klaviyo.com/api/accounts/",
  },
});
